/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "merchantein": {
        "nested": {
          "merchant": {
            "nested": {
              "MerchantPresenceHint": {
                "values": {
                  "BRICK_AND_MORTAR": 1,
                  "INTERNET": 2,
                  "PHONE": 3
                }
              },
              "Merchant": {
                "fields": {
                  "mcc": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "mid": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "canonicalName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 5,
                    "rule": "optional"
                  },
                  "geoLocation": {
                    "type": "squareup.common.location.GeoLocation",
                    "id": 6,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "parentMerchantToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "logoUrl": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "presenceHint": {
                    "type": "squareup.merchantein.merchant.MerchantPresenceHint",
                    "id": 11,
                    "rule": "optional"
                  },
                  "canonicalAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 12,
                    "rule": "optional"
                  },
                  "canonicalUrl": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "normalizedDescription": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "canonicalCategory": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "attributeSource": {
                    "type": "squareup.merchantein.merchant.Merchant.AttributeSource",
                    "id": 16,
                    "rule": "optional"
                  },
                  "descriptionFirstWord": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "descriptionPattern": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "unlimitedUnlinkedRefunds": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  },
                  "blacklisted": {
                    "type": "bool",
                    "id": 20,
                    "rule": "optional"
                  },
                  "nameUniqueEnoughForMatching": {
                    "type": "bool",
                    "id": 21,
                    "rule": "optional"
                  },
                  "brandColor": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "activeMerchantToken": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "phoneNumberConfirmed": {
                    "type": "bool",
                    "id": 24,
                    "rule": "optional"
                  },
                  "registerMerchantToken": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "logoUrlDarkTheme": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "brandColorDarkTheme": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "normalizedAddressHash": {
                    "type": "int64",
                    "id": 28,
                    "rule": "optional"
                  },
                  "registerUnitToken": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "affiliateLinkUrl": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "hasCanonicalNameOverride": {
                    "type": "bool",
                    "id": 31,
                    "rule": "optional"
                  },
                  "createdByBizzy": {
                    "type": "bool",
                    "id": 32,
                    "rule": "optional"
                  },
                  "canonicalNameSeller": {
                    "type": "string",
                    "id": 33,
                    "rule": "optional"
                  },
                  "apShopUrl": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "isParent": {
                    "type": "bool",
                    "id": 35,
                    "rule": "optional"
                  },
                  "isCashAppPayThirdParty": {
                    "type": "bool",
                    "id": 36,
                    "rule": "optional"
                  },
                  "aliasAfterpayStoreId": {
                    "type": "string",
                    "id": 40,
                    "rule": "optional"
                  },
                  "aliasAfterpayMerchantFingerprint": {
                    "type": "string",
                    "id": 41,
                    "rule": "optional"
                  },
                  "proxyParentMerchantToken": {
                    "type": "string",
                    "id": 43,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 46,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 47,
                    "rule": "optional"
                  },
                  "createdByBilly": {
                    "type": "bool",
                    "id": 48,
                    "rule": "optional"
                  },
                  "aliasPayMerchantId": {
                    "type": "string",
                    "id": 49,
                    "rule": "optional"
                  },
                  "aliasPayBrandId": {
                    "type": "string",
                    "id": 50,
                    "rule": "optional"
                  },
                  "aliasApiClientId": {
                    "type": "string",
                    "id": 51,
                    "rule": "optional"
                  },
                  "aliasBizzyToken": {
                    "type": "string",
                    "id": 52,
                    "rule": "optional"
                  },
                  "aliasParentBizzyToken": {
                    "type": "string",
                    "id": 53,
                    "rule": "optional"
                  },
                  "proxyChildMerchantToken": {
                    "type": "string",
                    "id": 54,
                    "rule": "optional"
                  },
                  "bizzyMetadata": {
                    "type": "squareup.merchantein.merchant.BizzyMetadata",
                    "id": 55,
                    "rule": "optional"
                  },
                  "payMetadata": {
                    "type": "squareup.merchantein.merchant.PayMetadata",
                    "id": 56,
                    "rule": "optional"
                  },
                  "aliasAfterpayMerchantId": {
                    "type": "string",
                    "id": 57,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AttributeSource": {
                    "values": {
                      "AUTO": 1,
                      "MANUAL": 2,
                      "FOURSQUARE": 3,
                      "INTERNAL_SERVICE": 4
                    }
                  }
                }
              },
              "BizzyMetadata": {
                "fields": {
                  "parentBizzyToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "mergedToBizzyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PayMetadata": {
                "fields": {
                  "payBrandId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "apiClientId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "payReferenceId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payLogoUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.merchantein?.nested?.merchant?.nested?.MerchantPresenceHint && !$root.nested?.squareup?.nested?.merchantein?.nested?.merchant?.nested?.Merchant && !$root.nested?.squareup?.nested?.merchantein?.nested?.merchant?.nested?.Merchant?.nested?.AttributeSource && !$root.nested?.squareup?.nested?.merchantein?.nested?.merchant?.nested?.BizzyMetadata && !$root.nested?.squareup?.nested?.merchantein?.nested?.merchant?.nested?.PayMetadata) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE MerchantPresenceHint @ squareup/merchantein/merchant/merchant.proto at 15:1
 */
export const MerchantPresenceHint = $root.lookupEnum('squareup.merchantein.merchant.MerchantPresenceHint').values;
/**
 * SOURCE Merchant @ squareup/merchantein/merchant/merchant.proto at 24:1
 */
export const Merchant = $root.lookupType('squareup.merchantein.merchant.Merchant');
fixType(Merchant);
Builder.createAndAttachToType(Merchant);
/**
 * SOURCE AttributeSource @ squareup/merchantein/merchant/merchant.proto at 81:3
 */
Merchant.AttributeSource = $root.lookupEnum('squareup.merchantein.merchant.Merchant.AttributeSource').values;
/**
 * Set of Bizzy Metadata associated with a merchant. Properties listed here
 * are for internal & transient properties, and should not be used other than Bizzy / Merchantein.
 *
 * Examples - ExSQ Pay, Bizzy, Merchantein
 *
 *
 * Ex-SQ$Pay       Bizzy             Merchantein
 * -----------     ------------      ------------
 * | BRAND_X | --> | B_parent | ---> | M_parent | ("Proxy Parent")
 * -----------     ------------  |   ------------
 *                               |        |
 *                               |   ------------
 *                               |-> | M_childA | ("Merchant" for $pay-brand)
 *                                   ------------
 * -----------     ------------      ------------
 * | MMI_Y   | --> | B_child  | ---> | M_childB | ("Merchant" for $pay-merchant)
 * -----------     ------------      ------------
 *
 * | Merchant Property                    | M_parent | M_childA     | M_childB     |
 * |:-------------------------------------|----------|--------------|--------------|
 * | parent_merchant_token                | -        | M_parent (1) | M_parent (1) |
 * | alias_pay_brand_id                   | -        | BRAND        | -            |
 * | alias_pay_merchant_id                | -        | -            | MMI_         |
 * | alias_bizzy_token                    | -        | B_parent     | B_child      |
 * | alias_parent_bizzy_token             | B_parent | -            | -            |
 * | proxy_parent_merchant_token          | -        | M_parent     | -            |
 * | proxy_child_merchant_token           | M_childA | -            | -            |
 * | bizzy_metadata.merged_to_bizzy_token | -        | - (2)        | -            |
 * | bizzy_metadata.parent_bizzy_token    | -        | -            | B_parent (3) |
 *
 * - (1) Child Merchants can be re-parented when identity is grouped under another canonical parent.
 * - (2) When $pay-brand Bizzy entity is merged with golden parent merchant,
 *       M_childA's `bizzy_metadata.merged_to_bizzy_token` is updated to merge target bizzy token.
 * - (3) $pay-merchants can be re-assigned to different $pay-brands,
 *       which `bizzy_metadata.parent_bizzy_token` can be updated.
 *
 * SOURCE BizzyMetadata @ squareup/merchantein/merchant/merchant.proto at 357:1
 */
export const BizzyMetadata = $root.lookupType('squareup.merchantein.merchant.BizzyMetadata');
fixType(BizzyMetadata);
Builder.createAndAttachToType(BizzyMetadata);
/**
 * SOURCE PayMetadata @ squareup/merchantein/merchant/merchant.proto at 387:1
 */
export const PayMetadata = $root.lookupType('squareup.merchantein.merchant.PayMetadata');
fixType(PayMetadata);
Builder.createAndAttachToType(PayMetadata);